import { normalize, schema } from 'normalizr'
import Vue from 'vue'

import { Api } from '@/utils/Api'
import UrlStore from '@/utils/UrlStore'
import setEntities from '@/utils/SetEntities'

export const POSITIONS_LOAD = 'POSITIONS_LOAD'
export const POSITION_LOAD = 'POSITION_LOAD'
export const POSITION_CREATE = 'POSITION_CREATE'
export const POSITION_UPDATE = 'POSITION_UPDATE'
export const POSITION_DESTROY = 'POSITION_DESTROY'
export const POSITION_STATE_UPDATE = 'POSITION_STATE_UPDATE'

const positionsApi = new Api(UrlStore.POSITIONS)
const positionSchema = new schema.Entity('positions')

export default {
  namespaced: true,
  state: {
    positionsLoaded: false,
    positionsList: [],
    entities: {
      positions: {}
    }
  },
  getters: {
    positions(state) {
      return state.positionsList.map((bId) => state.entities.positions[bId])
    },
    getPosition: (state) => (positionId) => state.entities.positions[positionId] || null
  },
  mutations: {
    [POSITIONS_LOAD](state, payload) {
      let normData = normalize(payload.items, [positionSchema])
      state.positionsList = normData.result
      setEntities(state, normData)
    },
    [POSITION_LOAD](state, payload) {
      let normData = normalize(payload, positionSchema)
      setEntities(state, normData)
    },
    [POSITION_CREATE](state, position) {
      state.positionsList.push(position.id)
      Vue.set(state.entities.positions, position.id, position)
    },
    [POSITION_UPDATE](state, position) {
      if (position.id && state.entities.positions[position.id]) {
        state.entities.positions[position.id] = Object.assign({}, state.entities.positions[position.id], position)
      }
    },
    [POSITION_DESTROY](state, position) {
      let num = state.positionsList.findIndex((cId) => cId === position.id)
      if (num !== -1) {
        state.positionsList.splice(num, 1)
        delete state.entities.positions[position.id]
      }
    },
    [POSITION_STATE_UPDATE](state, data) {
      for (let name of Object.keys(data)) {
        state[name] = data[name]
      }
    }
  },
  actions: {
    positionsLoad({ commit }, config = {}) {
      positionsApi.getAll(config).then((r) => {
        commit(POSITIONS_LOAD, r.data)
        commit(POSITION_STATE_UPDATE, { positionsLoaded: true })
      })
    },
    positionSave({ commit, getters }, position) {
      if (!position.id) throw new Error('Position id is not present in `positionSave`!')
      commit(getters.getPosition(position.id) ? POSITION_UPDATE : POSITION_CREATE, position)
      let positionUpdated = getters.getPosition(position.id)

      return positionsApi.save(positionUpdated).then((r) => {
        if (r._isNew) {
          commit(POSITION_DESTROY, positionUpdated) // local
          commit(POSITION_CREATE, r.data)
        } else {
          commit(POSITION_UPDATE, r.data)
        }
        return r.data.id
      })
    },
    positionDestroy({ commit }, position) {
      positionsApi.destroy({ id: position.id }).then(() => {
        commit(POSITION_DESTROY, position)
      })
    }
  }
}
